import React, { useState, useEffect } from "react";
import { API } from "@/App";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Loader2, Star } from "lucide-react";
import { SendIntakeForm } from "@/components/staff/SendIntakeForm";

export const RequestReviewButton = ({ patientId, token }) => {
  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState(null);
  useEffect(() => {
    if (!open) return;
    fetch(`${API}/staff/reviews/request-status/${patientId}`, { headers: { Authorization: `Bearer ${token}` } }).then(r => r.json()).then(setStatus).catch(() => setStatus({}));
  }, [open, patientId, token]);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" size="sm" className="text-xs rounded-lg" data-testid="request-review-btn"><Star className="w-3.5 h-3.5 mr-1" />Request review</Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-[340px] space-y-3" data-testid="request-review-popover">
        <div>
          <p className="text-sm font-semibold text-stone-900">Ask for a review</p>
          <p className="text-xs text-stone-500">Sends a private link (valid 60 days) where the patient can rate their care and share a story.</p>
        </div>
        {!status ? <Loader2 className="w-4 h-4 animate-spin text-stone-400" /> : (
          <SendIntakeForm patientId={patientId} token={token} email={status.has_email ? "yes" : ""} phone={status.phone} lastSent={status.last_sent}
            endpoint="/staff/reviews/request" noun="Review request" testPrefix="review-request" compact />
        )}
      </PopoverContent>
    </Popover>
  );
};
